import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propNumber, } from '../../../../../../../helpers/custom-prop-types';
import MoneyCircleIcon from '../../../../../../Icon/Svg/MoneyCircleIcon';
import RfpOneDescriptionPriceAverage from './RfpOneDescriptionPriceAverage';
const RfpOneDescriptionPrice = (props) => {
    const { diff, isSingleOffer, price } = props;
    return (_jsxs("div", Object.assign({ className: `rfp-description-number ${isSingleOffer ? 'is-single' : ''}` }, { children: [_jsx(MoneyCircleIcon, { className: 'number_icon gray' }), _jsx("span", Object.assign({ className: 'number_text' }, { children: price ? `${price.toLocaleString()}万円` : '-' })), !isSingleOffer && _jsx(RfpOneDescriptionPriceAverage, { diff: diff })] })));
};
RfpOneDescriptionPrice.propTypes = {
    diff: propNumber().isRequired,
    isSingleOffer: propBool().isRequired,
    price: propNumber().isRequired,
};
export default RfpOneDescriptionPrice;
